import * as React from "react";
import { Drawer,Input,Table} from "antd";
import Tag from "widget/detailHead/tag";
import _ from "lodash";
const { Search } = Input;
import { connect } from "react-redux";

interface IListdetailProps {
  Data:any;
  Visible:any;
  Reset:any;
  remarkList:any;
  remark:any;
  getOrderDetails:any;
  getRemarkList:any;
  tags:any;
  paymentlistForTag:any;
}

class Listdetail extends React.Component<IListdetailProps, any> {
  state = {
    visible:false,
    data:{},
    // remarklist:[],
    remark:'',
    id:'',
  };
  constructor(props: IListdetailProps) {
    super(props);
  }
  difference(object, base) {
    function changes(object, base) {
      return _.transform(object, function(result, value, key) {
        if (!_.isEqual(value, base[key])) {
          result[key] =
            _.isObject(value) && _.isObject(base[key])
              ? changes(value, base[key])
              : value;
        }
      });
    }
    return changes(object, base);
  }

  remarklist = (id) =>{
    this.setState({
      refresh: false,
    });
    const param: any = {
      id: id
    }; 
    this.props.getRemarkList({
      ...param,
      callback: (data) => {
      }
     });    
  }

  paymentlist = (id) =>{
    this.setState({
      refresh: false,
    });
    const param: any = {
      id: id
    }; 
    this.props.paymentlistForTag({
      ...param,
     });    
  }
  
  orderDetails = (id) =>{
    
    const params: any = {
      id: id
    }; 
    this.props.getOrderDetails({
       ...params,
       callback: () => {
       }
     });
  }

  addRemark = (remark) =>{
    if(remark == ''){
      return;
    }
    const param: any = {
      id: this.state.data['id'],
      remark:remark
    }; 
    this.props.remark({
      ...param,
      callback: (data) => {
       // console.log(data)
       this.setState({
          remark:''
       })
        this.remarklist(this.state.data['id']); 
      }
     });     
  }

  onChange = (value) =>{
    this.setState({
      remark:value.target.value
   })
  }

  shouldComponentUpdate(nextProps: any, nextState: any, preProps: any) {
    const keys = Object.keys(
      this.difference(nextProps.Data, this.state.data)
    );  
    console.log(keys)
    if ( keys.length > 0 && this.props.Visible!=nextProps.Visible ) {
      
      this.setState({
         data:nextProps.Data,
         id:nextProps.Data['id'],
         visible:nextProps.Visible
      })
      this.remarklist(nextProps.Data.id);
      this.orderDetails(nextProps.Data.id);
      /**
       * 退差时显示当前表格的值
       */
      this.paymentlist(nextProps.Data.id);
      return false;
    }
    return true;
  }

  onClose = () => {
    this.setState({
      visible: false,
      data: [],
      page: 0,
    });
    this.props.Reset();
  }; 
  

  render() {
    const dataSource = this.props.remarkList;
      
    const columns = [{
      title: '操作时间',
      dataIndex: 'create_time',
      key: 'create_time',
      width: 200,
      className:'th'
    },{
      title: '操作人',
      dataIndex: 'fullname',
      key: 'fullname',
      width: 200,
      className:'th',
      render: (text, row, index) => {
        return (
          <React.Fragment>
                <span>{row.role_name}  {row.fullname}</span>
          </React.Fragment>
        );
      }
    },{
      title: '内容',
      dataIndex: 'remark',
      key: 'remark',
      className:'th'
    }];

    return (
      <React.Fragment>
         <Drawer title="订单详情" width={650} placement="right" closable={false} onClose={this.onClose} visible={this.state.visible}>
               <ul className="list-detail-head">
                   <li>账号：{this.state.data['account']}</li>
                   <li>联系人电话：{this.state.data['phone']}</li>
                   <li>SKU名称：{this.state.data['skuName']}</li>
                   <li>出发日期：{this.state.data['goTime']}</li>
               </ul>  
               <div className="list-tag">
                   <Tag Tag={this.props.tags} OrderNo={this.state.id}/>
               </div>
               <div className="add-remark">
               <Search onChange={this.onChange} placeholder="备注内容" value={this.state.remark} enterButton="添加备忘录"  onSearch={this.addRemark} />
               </div>
               <Table className="ddd" bordered={true} expandIconAsCell={false} expandIconColumnIndex={-1} pagination={false} dataSource={dataSource} columns={columns} />          
        </Drawer>
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  user: state.userInfo.user,
  tags: state.orderDetails.tags,
  remarkList: state.orderDetails.remarkList
});

const mapDispatch = dispatch => {
  return {
    getRemarkList: dispatch.orderDetails.getRemarkList,
    remark: dispatch.orderDetails.remark,
    paymentlistForTag: dispatch.orderDetails.paymentlistForTag,
    getOrderDetails: dispatch.orderDetails.getOrderDetails,
  };
};


export default connect(
  mapState ,
  mapDispatch
)(Listdetail);